<template>
  <v-text-field
    ref="inputtext"
    :disabled="disabled"
    :rules="rules"
    :label="label"
    @input="change"
  />
</template>

<script>
export default {
  name: 'IgTextField',
  props: {
    value: {
      type: String,
      default: '',
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    rules: {
      type: Array,
      default: () => {
        return []
      },
      required: false,
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    status: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      internalData: this.value,
    }
  },
  watch: {
    value(val) {
      this.$refs.inputtext.lazyValue = val
    },
    status(val, oldval) {
      if (val && !oldval) {
        this.$refs.inputtext.lazyValue = ''
      }
      this.internalData = ''
    },
  },
  mounted() {
    this.$refs.inputtext.lazyValue = this.value
  },
  methods: {
    change(val) {
      this.internalData = val
      this.$emit('input', this.internalData)
    },
  },
}
</script>
